import { renderMarketingPage, SUPPORT_EMAIL } from './shared.js';

export function renderPrivacy(container, signedIn) {
  const body = `
    <main class="mkt-main">
      <section class="mkt-page-hero mkt-page-hero-legal">
        <h1>Privacy Policy</h1>
        <p>Last updated: 15 July 2026</p>
      </section>

      <section class="mkt-section mkt-prose">
        <p>
          This Privacy Policy explains what information Simustage collects, how it is used,
          and the choices you have. By using the Service, you agree to the practices described
          here.
        </p>

        <h2>1. Information we collect</h2>
        <p>
          <strong>Account information:</strong> name, email address, and authentication details
          when you sign up (including via Google sign-in).
        </p>
        <p>
          <strong>Content you create:</strong> the courses, topics, and messages you create
          while using the Service.
        </p>
        <p>
          <strong>Payment information:</strong> when you recharge your wallet or the monthly
          viewing charge is billed, payment is handled by our payment processor, Razorpay. We do
          not store your full card or bank details on our servers.
        </p>
        <p>
          <strong>Usage data:</strong> basic metering such as request counts, used to enforce
          plan limits and keep the Service reliable.
        </p>

        <h2>2. How we use information</h2>
        <ul>
          <li>To provide, maintain, and improve the Service</li>
          <li>To process payments and manage subscriptions</li>
          <li>To communicate with you about your account, billing, or support requests</li>
          <li>To keep the Service secure and prevent abuse</li>
        </ul>

        <h2>3. Sharing of information</h2>
        <p>
          We do not sell your personal information. We share information only with service
          providers who help us operate Simustage (such as our hosting and payment providers),
          and only to the extent needed for them to perform their services, or when required by
          law.
        </p>

        <h2>4. Data retention</h2>
        <p>
          We keep your account and content for as long as your account is active. Deleted
          courses and topics move to a recycle bin and are permanently removed after a short
          retention period. You can request full account deletion at any time from Settings.
        </p>

        <h2>5. Security</h2>
        <p>
          We use industry-standard measures, including authenticated access controls, to
          protect your data. No method of storage or transmission is completely secure, but we
          work to safeguard your information.
        </p>

        <h2>6. Your choices</h2>
        <ul>
          <li>Access, update, or delete your account information from Settings</li>
          <li>Export or remove content you have created</li>
          <li>Contact us to ask what data we hold about you</li>
        </ul>

        <h2>7. Children's privacy</h2>
        <p>
          Simustage is used by school-age learners, typically under the guidance of a parent,
          guardian, or teacher. We only collect information reasonably necessary to provide the
          Service and do not knowingly sell or share a child's personal information.
        </p>

        <h2>8. Changes to this policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will post the updated version
          here with a new "last updated" date.
        </p>

        <h2>9. Contact us</h2>
        <p>
          For privacy questions or requests, email
          <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>.
        </p>
      </section>
    </main>
  `;
  renderMarketingPage(container, '/privacy', signedIn, body);
}
